module.exports = __webpack_public_path__ + "img/2023_jeep-grand-cherokee.f60aebbf.png";